const charMap: Record<string, string> = {
  á: "a", à: "a", ã: "a", â: "a", é: "e", ê: "e", í: "i",
  ó: "o", ô: "o", õ: "o", ú: "u", ü: "u", ç: "c",
  Á: "A", À: "A", Ã: "A", Â: "A", É: "E", Ê: "E", Í: "I",
  Ó: "O", Ô: "O", Õ: "O", Ú: "U", Ü: "U", Ç: "C",
};

export function slugify(text: string): string {
  return text
    .split("")
    .map((c) => charMap[c] || c)
    .join("")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function neighborhoodSlug(neighborhood: string): string {
  return slugify(neighborhood);
}

/** Build the listing detail URL path */
export function listingPath(listing: { neighborhood: string; slug?: string | null; id: string }): string {
  const nSlug = neighborhoodSlug(listing.neighborhood);
  const lSlug = listing.slug || listing.id;
  return `/${nSlug}/${lSlug}`;
}
